module.exports = __webpack_public_path__ + "img/OHM_MIDDLE_MARKET_80X30.e58ed3e7.png";